module.exports = __webpack_public_path__ + "img/auth-阿虎医考金牌代理商奖一.97aed85f.png";